export const DO_LOGIN = 'DO_LOGIN';
export const DO_LOGIN_RES = 'DO_LOGIN_RES';

export const DO_LOADING_RES = 'DO_LOADING_RES';

export const CHECK_USER = 'CHECK_USER';
export const CHECK_USER_RES = 'CHECK_USER_RES';

export const DO_FORGOTPASSWORD = 'DO_FORGOTPASSWORD';
export const DO_FORGOTPASSWORD_RES = 'DO_FORGOTPASSWORD_RES';
export const DO_FORGOTPASSWORD_RES_ERR = 'DO_FORGOTPASSWORD_RES_ERR';

export const DO_RESETPASSWORD = 'DO_RESETPASSWORD';
export const DO_RESETPASSWORD_RES = 'DO_RESETPASSWORD_RES';
export const DO_RESETPASSWORD_RES_ERR = 'DO_RESETPASSWORD_RES_ERR';

export const REMAINING_DAYS_CHANGEPASSWORD = 'REMAINING_DAYS_CHANGEPASSWORD';
export const REMAINING_DAYS_CHANGEPASSWORD_RES = 'REMAINING_DAYS_CHANGEPASSWORD_RES';
export const REMAINING_DAYS_CHANGEPASSWORD_RES_ERROR = 'REMAINING_DAYS_CHANGEPASSWORD_RES_ERROR';

export const DO_EDITPROFILE = 'DO_EDITPROFILE';
export const DO_EDITPROFILE_RES = 'DO_EDITPROFILE_RES';

export const DO_OFFERING = 'DO_OFFERING';
export const DO_OFFERING_RES = 'DO_OFFERING_RES';

export const DO_OFFERING_DETAILS = 'DO_OFFERING_DETAILS';
export const DO_OFFERING_DETAILS_RES = 'DO_OFFERING_DETAILS_RES';

export const DO_GETPROFILE = 'DO_GETPROFILE';
export const DO_GETPROFILE_RES = 'DO_GETPROFILE_RES';

export const DO_OFFERING_USER_INFO = 'DO_OFFERING_USER_INFO';
export const DO_OFFERING_USER_INFO_RES = 'DO_OFFERING_USER_INFO_RES';


